import { FC } from 'react';
import useStore from '@hooks/useStore';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import CopyToClipboard from '@components/CopyToClipboard';

import { ReactComponent as CopyIcon } from '@assets/images/icons/copy.svg';

import useStyles from './styles';

export interface InfoItem {
  key: string;
  label: string;
  value: string;
  formattedValue?: string;
}

export interface IGenericAnotherBankTab {
  title: string;
  referenceInfo: InfoItem[];
  copyLabel: string;
}

const GenericAnotherBankTab: FC<IGenericAnotherBankTab> = ({ title, referenceInfo, copyLabel }) => {
  const {
    links: {
      coBrandingConfig: { primaryColor, secondaryColor },
    },
  } = useStore();
  const css = useStyles({ primaryColor, secondaryColor });

  return (
    <div data-testid="generic-another-bank-tab" className={css.root}>
      <div data-testid="generic-another-tab-bank-title" className={css.caption}>
        {title}
      </div>
      <div className={css.speiInfo}>
        {referenceInfo.map((item) => {
          const value = item.formattedValue || item.value;
          return (
            <Box display="flex" key={item.key} alignItems="center" justifyContent="space-between">
              <Box>
                <div className={css.label}>{item.label}</div>
                <div className={css.value}>{value}</div>
              </Box>
              <Box>
                <IconButton className={css.copyIcon}>
                  <CopyToClipboard tooltipText={copyLabel} text={item.value}>
                    <SvgIcon component={CopyIcon} />
                  </CopyToClipboard>
                </IconButton>
              </Box>
            </Box>
          );
        })}
      </div>
    </div>
  );
};

export default GenericAnotherBankTab;
